var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container",style:({ height: _vm.height })},[_c('div',{ref:"map",staticStyle:{"height":"100%","width":"100%","border-radius":"10px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }